import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';

const useStyles = makeStyles(theme => ({
    listHeading: {
        listStyleType: 'none',
        position: 'relative',
    }
}));

const ComplaintAndFeedbackStatic = () => {
    const classes = useStyles();

    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    return (
        <Box sx={{
            p: '1rem',
            backgroundColor: '#DCF1F0'
        }}>
            <Box sx={{
                maxWidth: '85rem',
                margin: 'auto'
            }}>
                <Box sx={(theme) => ({
                    display: 'flex',
                    padding: 0,
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    [`${theme.breakpoints.down('sm')}`]: {
                        flexDirection: 'column'
                    }
                })}>
                    <Typography sx={{ flexBasis: '70%' }}>
                        <>
                            <Typography variant='h5' sx={(theme) => ({
                                color: 'text.secondary',
                                fontSize: '2rem',
                                fontWeight: 'bold',
                                mb: 3
                            })}>
                                Complaint And Feedback
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Our Aim
                            </Typography>
                            <Typography component="div">
                                <p>MediRadar is committed to providing a quality service and working in an open and accountable way that builds trust and respect. One of the ways in which we can continue to improve our service is by listening and responding to the views of our clients and stakeholders, and in particular by responding positively to complaints, and by putting mistakes right.</p>

                                <p>Therefore we aim to ensure that:</p>
                                <ul>
                                    <li><p>making a compliment or complaint is as easy as possible</p></li>
                                    <li><p>we welcome compliments, feedback and suggestions</p></li>
                                    <li><p>we treat a complaint as a clear expression of dissatisfaction with our service which calls for an immediate response</p></li>
                                    <li><p>we deal with it promptly, politely and, when appropriate, confidentially</p></li>
                                    <li><p>we respond in the right way - for example, with an explanation, or an apology where we have got things wrong, or information on any action taken etc.</p></li>
                                    <li><p>we learn from complaints, use them to improve our service, and review annually our complaints policy and procedures</p></li>
                                </ul>

                                <p>We recognise that many concerns will be raised informally, and dealt with quickly.</p>

                                <p>Our aims are to:</p>
                                <ul>
                                    <li><p>resolve informal concerns quickly</p></li>
                                    <li><p>keep matters low-key</p></li>
                                    <li><p>enable mediation between the complainant and the individual to whom the complaint has been referred</p></li>
                                </ul>

                                <p>This policy ensures that we welcome compliments and provide guidelines for dealing with complaints from members of the public about our services, facilities, staff and volunteers.</p>
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Definitions
                            </Typography>
                            <Typography component="div">
                                <p>A compliment is an expression of satisfaction about the standard of service we provide.</p>
                                <p>A complaint is defined as any expression of dissatisfaction, however, it is expressed. This would include complaints expressed face to face, via a phone call, in writing, via email or any other method. All staff should have sufficient knowledge to be able to identify an "expression of dissatisfaction" even when the word "complain" or "complaint" is not used.</p>
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Purpose
                            </Typography>
                            <Typography component="div">
                                <p>We are always glad to hear from people who are satisfied with the services we offer. All compliments are recorded, acknowledged, and a copy is sent to the relevant service manager to provide feedback to the member of staff or service.</p>
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Complaints
                            </Typography>
                            <Typography component="div">
                                <p>The formal complaints procedure is intended to ensure that all complaints are handled fairly, consistently and wherever possible resolved to the complainant's satisfaction.</p>
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Responsibilities
                            </Typography>
                            <Typography component="div">
                                <p>MediRadar responsibility will be to:</p>
                                <ul>
                                    <li><p>acknowledge the formal complaint in writing;</p></li>
                                    <li><p>respond within a stated period of time;</p></li>
                                    <li><p>deal reasonably and sensitively with the complaint; and</p></li>
                                    <li><p>take action where appropriate.</p></li>
                                </ul>

                                <p>A complainant's responsibility is to:</p>
                                <ul>
                                    <li><p>bring their complaint, in writing, to MediRadar's attention normally within 8 weeks of the issue arising;</p></li>
                                    <li><p>raise concerns promptly and directly with a member of staff in MediRadar;</p></li>
                                    <li><p>explain the problem as clearly and as fully as possible, including any action taken to date;</p></li>
                                    <li><p>allow MediRadar a reasonable time to deal with the matter, and</p></li>
                                    <li><p>recognise that some circumstances may be beyond MediRadar's control.</p></li>
                                </ul>
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Confidentiality
                            </Typography>
                            <Typography component="div">
                                <p>Except in exceptional circumstances, every attempt will be made to ensure that both the complainant and MediRadar maintain confidentiality. However the circumstances giving rise to the complaint may be such that it may not be possible to maintain confidentiality (with each complaint judged on its own facts). Should this be the case, the situation will be explained to the complainant.</p>
                            </Typography>

                            <Typography variant="h6" className={classes.listHeading}>
                                Complaints Procedure
                            </Typography>
                            <Typography component="div">
                                <p>Written records must be made by MediRadar at each stage of the procedure.</p>

                                <Typography variant="h6" className={classes.listHeading}>
                                    Stage 1
                                </Typography>
                                <p>In the first instance, staff member(s) must establish the seriousness of the complaint. An informal approach is appropriate when it can be achieved. But if concerns cannot be satisfactorily resolved informally, then the formal complaints procedure should be followed.</p>

                                <Typography variant="h6" className={classes.listHeading}>
                                    Stage 2
                                </Typography>
                                <p>If the complaint cannot be resolved informally, the member of the public should be advised that a formal complaint may be made and the following procedure should be explained to them. It may sometimes be appropriate for a different member of staff, preferably a member of the Management Team, to make this explanation.</p>
                                <ul>
                                    <li>A formal complaint can be made either verbally or in writing. If in writing the attached form should be used. If verbally, a statement should be taken by a member of the Management Team, staff member or a supervisor.</li>
                                    <li>In all cases, the complaint must be passed on to CMO. In the event of a complaint about the CMO the complaint should be passed to the CEO, and if the complaint is about the CEO this must be passed on to Board.</li>
                                    <li>The CMO or CEO, depending on the nature of the complaint, must acknowledge the complaint in writing within one week of receiving it.</li>
                                    <li>One of the above will investigate the complaint. Any conclusions reached should be discussed with the staff member involved and their Line Manager.</li>
                                    <li>The person making the complaint will receive a response based on the investigation within four weeks of the complaint being received. If this is not possible then a letter must be sent explaining why.</li>
                                </ul>

                                <Typography variant="h6" className={classes.listHeading}>
                                    Stage 3
                                </Typography>
                                <ul>
                                    <li>If the complainant is not satisfied with the above decision then a sub-group of the Trustee Board will be convened.</li>
                                    <li>The sub-group will examine the complaint and may wish to carry out further interviews, examine files / notes. They will respond within four weeks in writing. Their decision will be final.</li>
                                </ul>
                            </Typography>
                        </>
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default ComplaintAndFeedbackStatic;
